import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/major_tom/mt_icon.png'


const _hoisted_1 = { class: "flex items-center gap-3 p-3 border-b border-border hover:bg-primary/5 transition-colors" }
const _hoisted_2 = { class: "flex-1 min-w-0" }
const _hoisted_3 = { class: "text-sm font-semibold text-foreground truncate" }
const _hoisted_4 = { class: "flex items-center justify-between gap-2 text-xs text-muted-foreground" }
const _hoisted_5 = { class: "font-semibold text-foreground" }

import type { ICartItemRequest, IProductRequest } from '@/data/_autogen/IValveVista';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartItemRow',
  props: {
    item: {},
    product: {}
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

const handleDelete = () => {
  emit('delete', props.item.productId!);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Major Tom Icon",
        class: "h-auto"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.item.productName || 'Unknown Product'), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(__props.item.quantity) + "x", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(formatCurrency((__props.item.unitPrice || 0) * (__props.item.quantity || 0))), 1)
      ])
    ]),
    _createElementVNode("button", {
      class: "flex-shrink-0 p-2 text-muted-foreground hover:text-accent transition-colors rounded-lg hover:bg-accent/10",
      "aria-label": "Delete item",
      onClick: handleDelete
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'trash-can'],
        class: "text-sm"
      })
    ])
  ]))
}
}

})